<template>
  <section class="content">
    <v-layout justify-center>
      <v-container fluid grid-list-md>
        <v-alert
          :value="showConnectionError"
          type="error"
        >Couldn't Connect to Post Service! Please Comeback Later!</v-alert>
        <v-layout row wrap>
          <v-flex md12 xs12 sm12>
            <v-layout row wrap>
              <v-flex xs12 md3 sm6>
                <v-autocomplete
                  v-model="filter.campaignID"
                  item-value="id"
                  item-text="name"
                  :items="campaigns"
                  label="Campaign Filter"
                  hide-details
                  outlined
                  auto-select-first
                  @change="search"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md3 sm6>
                <v-text-field
                  :hide-details="true"
                  v-model="filter.instagramHandle"
                  :height="56"
                  label="Filter by Handle"
                  outlined
                  v-on:keyup.enter="search"
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                md2
                sm6
              >
                <v-autocomplete
                  :hide-details="true"
                  item-text="name"
                  item-value="id"
                  v-model="filter.clientID"
                  :items="clients"
                  :outlined="true"
                  label="Client"
                  auto-select-first
                  @change="search"
                ></v-autocomplete>
              </v-flex>
              <v-flex
                xs12
                md2
                sm6
                v-if="currentUserRole !== userRoles.INFLUENCER && currentUserRole !== userRoles.CLIENT"
              >
                <v-autocomplete
                  :hide-details="true"
                  item-text="text"
                  item-value="value"
                  v-model="filter.filterStatus"
                  :items="statuses"
                  :outlined="true"
                  label="Status"
                  auto-select-first
                  @change="search"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md1 sm6>
                <v-btn @click="resetFilter" class="mt-2 primary">Reset</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md12 xs12 sm12>
            <v-data-table
              :headers="statusReportHeaders"
              :items="reportData"
              item-key="id"
              class="elevation-1"
              :options.sync="pagging"
              :server-items-length="pagging.totalItems"
            >
              <template v-slot:[`item.handle`]="{ item }">
                <a
                  :href="'https://www.tiktok.com/@' + item.author.tiktokHandle"
                  target="_blank"
                  v-if="item.author.tiktokHandle"
                ><img src="/static/img/tiktok-32.png" width="20px" /> @{{item.author.tiktokHandle}}</a>
                <a
                  :href="'https://youtube.com/' + item.author.youtubeHandle"
                  target="_blank"
                  v-else-if="item.author.youtubeHandle"
                ><v-icon>mdi-youtube</v-icon> @{{item.author.youtubeHandle}}</a>
                <a
                  :href="'https://instagram.com/' + item.author.instagramHandle"
                  target="_blank"
                  v-else
                ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{item.author.instagramHandle}}</a>
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <div v-for="label in item.labels" :key="label.text">
                  <v-chip
                    class="ma-1"
                    small
                    :color="label.color"
                    :outlined="label.outlined"
                    :dark="label.dark"
                  >
                    {{label.text}}
                    <v-icon right>{{label.icon}}</v-icon>
                  </v-chip>
                </div>
              </template>
              <template v-slot:[`item.submittedDate`]="{ item }">
                <div>
                  {{item.submittedDate}} <v-icon v-if="item.hasReport || item.postURL" color="green" data-toggle="tooltip" data-placement="bottom" title="Live Post">mdi-check</v-icon>
                </div>
              </template>
              <template v-slot:[`item.payoutDueDate`]="{ item }">
                <div>
                  {{item.payoutDueDate}} <v-icon v-if="item.payoutSubmitted" color="green" data-toggle="tooltip" data-placement="bottom" title="Payout Submitted">mdi-check</v-icon>
                </div>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <div class="mb-2">
                <v-btn class="mt-2 primary" small @click="viewDetailPost(item)">
                  View Post&nbsp;<v-icon small>mdi-magnify</v-icon>
                </v-btn>
                <v-btn
                  class="mt-2 primary"
                  v-on="on"
                  :to="`/campaignPayoutsInternal?influencerID=${item.influencerID}&campaignID=${item.campaignID}`"
                  target="_blank"
                  :disabled="!item.payout"
                  small
                >
                  View Submitted Payouts&nbsp;<v-icon small>mdi-image-multiple</v-icon>
                </v-btn>
                <v-menu bottom left>
                  <template v-slot:activator="{ on }">
                    <v-btn class="mt-2 primary" small v-on="on">Action</v-btn>
                  </template>

                  <v-list>
                    <v-list-item
                      v-for="(menuItem, i) in menuOptions"
                      :key="i"
                      @click="actionPostBy(menuItem.action, item)"
                    >
                      <v-list-item-content>{{menuItem.name}}</v-list-item-content>
                      <v-list-item-action>
                        <v-icon>{{menuItem.icon}}</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-menu>
                  <!-- <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      color="secondary"
                      class="ims-action"
                      v-on="on"
                      @click="viewImages(item)"
                    >
                      <v-icon>mdi-image-multiple</v-icon>
                    </v-btn>
                  </template>
                  <span>View Submitted Payouts</span>
                </v-tooltip> -->
                </div>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <loading
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="true"
        loader="bars"
        background-color="#000"
        color="secondary"
        width.number="180"
        height.number="180"
      />
    <view-post-modal
      v-model="viewPostDialog"
      :post="viewPostData"
      :csActions="showCsEditAction"
      :saleActions="showSaleAction"
      :clientActions="showClientEditAction"
      :influencerActions="showInfluencerEditAction"
      :cs_inf_chatbox="show_cs_inf_chatbox"
      :postAbuseHistory="showPostAbuseHistory"
      :postReviewApproved="showPostReviewApproved"
      :postHistory="showPostHistory"
      :userObj="user"
      :value="viewPostDialog"
      @csApproved="csApproveFromView"
      @saleReleased="saleReleasePost"
      @editPost="editPostFromView"
      @mainPostChanged="reloadPostView"
    />

    <edit-post-modal
      v-model="editPostDialog"
      :post="editPostData"
      :postAbuseHistory="true"
      @postUpdated="getStatusReport()"
      :value="editPostDialog"
      :userObj="user"
    />

    <assign-campaign-modal
      v-model="assignCampaignDialog"
      :post="assignCampaignPostData"
      @success="assignedCampaign($event)"
    />
    <map-influencer-modal
      v-model="mapInfluencerDialog"
      :post="mapInfluencerPostData"
      @successInfluencerMap="getStatusReport()"
    />
    <submission-review-multiple-modal
      v-model="submissionReviewMultipleDialog"
      :posts="selected"
      :internalApprove="true"
      @successBulkApprove="getStatusReport()"
    />
    <add-post-to-campaign
      v-model="addPostToCampaign"
      :value="addPostToCampaign"
      :campaign="campaignDataForAddPost"
      :postID="postIdToUpdate"
      :post="addPost"
      @done="postAdded"
    ></add-post-to-campaign>
    <change-post-status-modal
      v-model="changeStatusDialog"
      :post="postDataForChangeStatus"
      :postIds="changePostIds"
      @updated="getStatusReport()"
    />
    <v-dialog v-model="loading" hide-overlay persistent width="250">
      <v-card color="primary">
        <v-card-text class="loading-dialog-text">
          Please stand by
          <v-progress-linear indeterminate color="secondary" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
import { mapState } from 'vuex';
import postConfig from './postConfig';
import config from '@/config';
import PostAPI from './postApi';
import campaignAPIs from '../Campaign/campaignAPIs';
import clientAPIs from '../Client/clientAPIs';
import influencerAPIs from '../Influencer/influencerAPIs';
import paymentAPIs from '../Influencer/paymentAPIs'
import EditPostModal from './EditPost.vue';
import ViewPostModal from './ViewPostModal.vue';
import Loading from 'vue-loading-overlay';
import moment from 'moment';
import AssignCampaignModal from './AssignCampaignModal.vue';
import MapInfluencerModal from './MapInfluencerModal.vue';
import SubmissionReviewMultipleModal from './SubmissionReviewMultiple.vue';
import AddPostToCampaign from '../../scoped/campaign/AddPostToCampaign';
import ChangePostStatusModal from './ChangePostStatusModal';
import campaignHelper from '../Campaign/campaignHelper';
import CustomMediaV2 from '../../scoped/custom/CustomMediaV2';
// import Utils from '../../../utils';

export default {
  name: 'Cocreating_Status_Report',
  components: {
    ViewPostModal,
    EditPostModal,
    AddPostToCampaign,
    ChangePostStatusModal,
    AssignCampaignModal,
    MapInfluencerModal,
    SubmissionReviewMultipleModal,
    CustomMediaV2,
    Loading
  },
  data() {
    return {
      showConnectionError: false,
      loading: false,
      campaigns: [],
      clients: [],
      filter: {
        instagramHandle: '',
        campaignID: '',
        clientID: '',
        filterStatus: '',
        status: [
          config.postStatus.AD_STRATEGIST_PENDING,
          config.postStatus.CLIENT_PENDING,
          config.postStatus.APPROVE
        ]
      },
      reportData: [{
        campaignName: 'New Campaign',
        influencers: [
          {
            handle: 'N/A',
            submissionDate: '15/9/21',
            submittedDate: '16/9/21',
            status: 'Pending Client',
            deliverable: 'IGP'
          }
        ]
      }],
      editPostData: {},
      assignCampaignPostData: {},
      mapInfluencerPostData: {},
      viewPostDialog: false,
      editPostDialog: false,
      showCsEditAction: false,
      showSaleAction: false,
      showClientEditAction: false,
      showInfluencerEditAction: false,
      show_cs_inf_chatbox: false,
      showPostAbuseHistory: false,
      showPostReviewApproved: false,
      assignCampaignDialog: false,
      mapInfluencerDialog: false,
      addPostToCampaign: false,
      showPostHistory: false,
      viewPostData: {},
      viewScreenShotsDialog: false,
      changeStatusDialog: false,
      postDataForChangeStatus: null,
      imagesToView: [],
      campaignHelper,
      defaultPoster: {
        instagramHandle: '-------',
        picture: '/static/img/kobe_bg_main.png'
      },
      pagging: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
        groupDesc: false
      },
      // statusReportHeaders: [
      //   {
      //     'text': 'Client Name',
      //     'align': 'start',
      //     'value': 'clientName',
      //     'sortable': true,
      //     'groupable': false
      //   },
      //   {
      //     'text': 'Campaign Name',
      //     'align': 'start',
      //     'value': 'name',
      //     'sortable': true,
      //     'groupable': false
      //   }
      // ],
      statusReportHeaders: [
        {
          'text': 'Campaign',
          'align': 'start',
          'value': 'campaignName',
          'sortable': false
        },
        {
          'text': 'Handle',
          'align': 'start',
          'value': 'handle',
          'sortable': false
        },
        {
          'text': 'Status',
          'align': 'start',
          'value': 'status',
          'sortable': false
        },
        {
          'text': 'Post Status',
          'align': 'start',
          'value': 'postStatus',
          'sortable': false
        },
        {
          'text': 'Submission Date',
          'align': 'start',
          'value': 'submissionDate',
          'sortable': false
        },
        {
          'text': 'Live Date',
          'align': 'start',
          'value': 'submittedDate',
          'sortable': false
        },
        {
          'text': 'Format',
          'align': 'start',
          'value': 'format',
          'sortable': true
        },
        {
          'text': 'Payout Due Date',
          'align': 'start',
          'value': 'payoutDueDate',
          'sortable': false
        },
        {
          'text': 'Action',
          'align': 'start',
          'value': 'action',
          'sortable': false
        }
      ]
    }
  },
  watch: {
    pagging(newValue) {
      this.filter = Object.assign({}, this.filter, newValue)
      this.getStatusReport();
    }
  },
  computed: {
    user: function() {
      return this.$store.state.user;
    },
    userRoles: function() {
      return config.userRoles;
    },
    currentUserID: function() {
      return this.$store.state.user.id;
    },
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    postStatusConfig: function() {
      return config.postStatus;
    },
    statuses: function() {
      return postConfig.postFilterStatuses.filter(filterStatus => filterStatus.value !== postConfig.postFilterStatus.ABUSE_PENDING_RELEASE)
    },
    ...mapState({
      postUpdateStatus: state => state.post.updated
    })
  },
  async mounted() {
    console.log('mounted')
    try {
      if (this.$route.query.handle) {
        this.filter.instagramHandle = this.$route.query.handle
      }
      if (this.$route.query.campaignID) {
        this.filter.campaignID = this.$route.query.campaignID
      }
      this.filter = Object.assign({}, this.filter, this.pagging)
      this.resetPaging()
      this.getStatusReport()
      // get campaigns
      const resp = await campaignAPIs.getUnfinishedCampaigns();
      this.campaigns = [{id: '', name: 'All Campaigns'}, ...resp]
      // get clients
      const clientResp = await clientAPIs.getAllClients();
      this.clients = clientResp.data
      let clientIDs = [...new Set(this.campaigns.map(c => c.clientID))]
      this.clients = this.clients.filter(b => clientIDs.includes(b.id))
      this.clients.unshift({id: '', name: 'All Clients'})
    } catch (error) {
      console.log(error);
      this.$swal({
        text: 'Cannot fetch required data!',
        icon: 'error'
      });
    }
  },
  methods: {
    async getStatusReport() {
      this.loading = true
      let resp = await PostAPI.getStatusReportData(this.filter)
      this.reportData = resp.posts
      this.pagging.totalItems = resp.totalItems
      this.reportData = this.reportData.map(post => {
        post.labels = this.getPostLabels(post)
        post.author = post.author || this.defaultPoster
        post.postStatus = this.loadPostStatusDisplay(post)
        return post
      })
      this.getAllCampaignPayouts()
      this.loading = false
      this.filterTableActions();
      this.filterMenuOptions();
    },
    loadPostStatusDisplay(newPost) {
      return config.postStatusDisplayInternal[newPost.status].display
    },
    getPostLabels(post) {
      let labels = [];
      if (post.status === this.postStatusConfig.AD_STRATEGIST_PENDING) {
        if (!post.campaignID) {
          labels.push({
            text: 'Campaign not assigned',
            icon: 'warning',
            outlined: true,
            dark: false,
            color: 'red',
            action: 'assignCampaignToPost'
          });
        }
        if (post.waiting_release && !post.abuse_resolved) {
          labels.push({
            text: 'Pending to release',
            icon: 'nights_stay',
            outlined: true,
            dark: false,
            color: 'secondary',
            action: 'viewDetailPost'
          });
        }
      }
      if ((this.currentUserRole <= this.userRoles.AD_STRATEGIST ||
      this.currentUserRole === this.userRoles.ACCOUNT_MANAGER) && post.abuse_resolved) {
        labels.push({
          text: 'Pending to release',
          icon: 'nights_stay',
          outlined: true,
          dark: false,
          color: 'blue',
          action: 'viewDetailPost'
        });
      }

      if (
        !post.waiting_release &&
        post.status === this.postStatusConfig.AD_STRATEGIST_PENDING) {
        labels.push({
          text: 'Work in progress by CC',
          icon: 'nights_stay',
          outlined: true,
          dark: false,
          color: 'red',
          action: 'viewDetailPost'
        });
      }

      if (post.status === this.postStatusConfig.CLIENT_PENDING &&
      this.currentUserRole !== this.userRoles.INFLUENCER && !post.abuse_resolved && post.release_abuse_resolved) {
        labels.push({
          text: 'Abuse Resolved',
          icon: 'check',
          color: 'green',
          action: 'viewDetailPost'
        });
      }

      if (post.status === this.postStatusConfig.CLIENT_PENDING &&
      !post.abuse_resolved &&
      !post.release_abuse_resolved) {
        if (this.isIncludeInAbuseReport(post.draftId, post.clientReportAbuse)) {
          if (post.additional_abuse_reported) {
            labels.push({
              text: 'Additional Abuse Reported',
              icon: 'warning',
              outlined: true,
              dark: false,
              color: 'deep-orange',
              action: 'viewDetailPost'
            });
          } else {
            labels.push({
              text: 'Abuse Reported',
              icon: 'warning',
              outlined: true,
              dark: false,
              color: 'deep-orange'
            });
          }
        } else {
          if (post.viewUsers && post.viewUsers.includes(this.currentUserID)) {
            labels.push({
              text: 'Viewed',
              outlined: true,
              dark: false,
              icon: 'remove_red_eye',
              color: 'grey',
              action: 'viewDetailPost'
            });
          } else {
            labels.push({
              text: 'New',
              outlined: true,
              dark: false,
              icon: 'new_releases',
              color: 'primary'
            });
          }
        }
      }

      // if (post.status === this.postStatusConfig.LIVE) {
      //   labels.push({
      //     text: 'Live',
      //     icon: ' mdi-television',
      //     outlined: true,
      //     dark: false,
      //     color: 'secondary'
      //   });
      // }

      if (post.status === this.postStatusConfig.APPROVE && !post.postURL) {
        labels.push({
          text: 'Approved',
          icon: 'assignment_turned_in',
          color: 'primary'
        });
      }

      // if (post.status === this.postStatusConfig.COMPLETE) {
      //   labels.push({
      //     text: 'Completed',
      //     icon: 'check',
      //     outlined: true,
      //     dark: false,
      //     color: 'green'
      //   });
      // }

      if (post.postURL) {
        labels.push({
          text: 'Post URL Added',
          icon: 'check',
          color: 'green'
        });
      }
      if (post.hasReport) {
        labels.push({
          text: 'Present in Campaign Report',
          icon: 'check',
          color: 'primary'
        });
      }
      return labels;
    },
    formatDate(date, format = 'll') {
      return moment(date).format(format);
    },
    checkAfter(date) {
      return moment(this.currentDate).isAfter(date);
    },
    checkSame(date) {
      return moment(this.currentDate).isSame(date);
    },
    isIncludeInAbuseReport(reportedDraftId, clientReportArr) {
      if (!clientReportArr) return [];
      let tmpArr = clientReportArr.map(item => item.draftPostId);
      return tmpArr.includes(reportedDraftId);
    },
    search() {
      this.resetPaging()
      this.getStatusReport()
    },
    viewDetailPost(post) {
      if (post.status < config.postStatus.APPROVE && this.currentUserRole === config.userRoles.AD_STRATEGIST && !post.waiting_release) {
        this.showCsEditAction = true;
      } else {
        this.showCsEditAction = false;
      }
      if (post.status < config.postStatus.APPROVE && this.currentUserRole === config.userRoles.ACCOUNT_MANAGER && post.waiting_release) {
        this.showSaleAction = true;
      } else {
        this.showSaleAction = false;
      }
      if (post.status === config.postStatus.CLIENT_PENDING && this.currentUserRole === config.userRoles.CLIENT) {
        this.showClientEditAction = true;
      } else {
        this.showClientEditAction = false;
      }
      if (post.status < config.postStatus.APPROVE && this.currentUserRole === config.userRoles.INFLUENCER) {
        this.showInfluencerEditAction = true;
      } else {
        this.showInfluencerEditAction = false;
      }
      if ((this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.AD_STRATEGIST || this.currentUserRole === config.userRoles.INFLUENCER) &&
        post.campaignID
      ) {
        this.show_cs_inf_chatbox = true;
      } else {
        this.show_cs_inf_chatbox = false;
      }
      if (post.clientReportAbuse) {
        this.showPostAbuseHistory = true;
      } else {
        this.showPostAbuseHistory = false;
      }
      if (post.status === config.postStatus.APPROVE || post.status === config.postStatus.LIVE && this.currentUserRole !== config.userRoles.INFLUENCER) {
        this.showPostReviewApproved = true;
      } else {
        this.showPostReviewApproved = false;
      }
      if (post.status < config.postStatus.APPROVE) {
        this.showPostHistory = true;
      } else {
        this.showPostHistory = false;
      }
      this.fetchPost(post._id).then((post) => {
        this.viewPostData = post;
      });
      this.viewPostDialog = true;
    },
    fetchPost(postId) {
      return new Promise((resolve, reject) => {
        PostAPI.getPostById(postId)
        .then(post => {
          resolve(post)
        })
        .catch(err => {
          this.$swal({
            title: `Couldn't the Post`,
            type: 'error',
            text: err
          });
          reject(err);
        });
      })
    },
    csApproveFromView: function(post) {
      this.csApprovePost(post);
    },
    csApprovePost(post) {
      if (!post.campaignID) {
        this.$swal({
          title: 'Please select the campaign for this post',
          type: 'warning'
        });
      } else if (!post.postDate) {
        this.$swal({
          title: 'Edit the post publishing date first before sending to client.',
          type: 'warning'
        });
      } else if (post.waiting_release) {
        this.$swal({
          title: 'Already Submitted',
          text: 'You have already approved this draft.\nIt is now pending to release from AM.',
          type: 'info'
        });
      } else {
        let id = post._id;
        this.approvePosts([id]);
      }
    },
    approvePosts(postIds) {
      this.$swal({
        title: 'Are you sure?',
        text: 'Upon confirmation, the post will be sent to AM for approval',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Agree',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return PostAPI.approvePost(postIds)
            .then(data => {
              return data;
            })
            .catch(error => {
              console.error(error);
              this.$swal({
                title: 'Error in approving Post, please try again',
                type: 'error'
              });
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Show success message
          this.$swal({
            title: 'Success',
            text: 'The draft is now waiting for release from AM.\nOnced released, it will sent to client.',
            type: 'success'
          });
          // Reload Page
          // this.$router.push({ path: '/posts/pending-kobe' });
          this.$emit('input');
          this.getStatusReport();
          this.viewPostDialog = false;
        } else {
          // Do nothing for now
        }
      });
    },
    abuseResolvePosts(postIds) {
      this.$swal({
        title: 'Are you sure?',
        text: 'Upon confirmation, the post will be sent to AM for abuse resolved',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Agree',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return PostAPI.abuseResolvePost(postIds)
            .then(data => {
              return data;
            })
            .catch(error => {
              console.error(error);
              this.$swal({
                title: 'Error in abuse resolving Post, please try again',
                type: 'error'
              });
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Show success message
          this.$swal({
            title: 'Success',
            text: 'The abuse resolved draft is now waiting for release from AM.\nOnced released, it will sent to client.',
            type: 'success'
          });
          // Reload Page
          // this.$router.push({ path: '/posts/pending-kobe' });
          this.$emit('input');
          this.getPosts();
          this.viewPostDialog = false;
        } else {
          // Do nothing for now
        }
      });
    },
    releaseAbuseResolvedPosts(postIds) {
      this.$swal({
        title: 'Are you sure?',
        text: 'Upon confirmation, the post will be released to client as abuse resolved',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Agree',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return PostAPI.releaseAbuseResolvePost(postIds)
            .then(data => {
              return data;
            })
            .catch(error => {
              console.error(error);
              this.$swal({
                title: 'Error in releasing Post, please try again',
                type: 'error'
              });
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Show success message
          this.$swal({
            title: 'Success',
            text: 'The abuse resolved draft is sent to client.',
            type: 'success'
          });
          // Reload Page
          // this.$router.push({ path: '/posts/pending-kobe' });
          this.$emit('input');
          this.getPosts();
          this.viewPostDialog = false;
        } else {
          // Do nothing for now
        }
      });
    },
    saleReleasePost(post) {
      if (!post.waiting_release) {
        this.$swal({
          title: 'The post is not submitted by CC yet',
          type: 'warning'
        });
      } else {
        let id = post._id;
        this.releasePosts([id]);
      }
    },
    releasePosts(postIds) {
      let postConfirmationText = postConfig.postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        type: postConfirmationText['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: postConfirmationText['confirmation']['confirmText'],
        cancelButtonText: postConfirmationText['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return PostAPI.releasePost(postIds)
            .then(data => {
              return data;
            })
            .catch(error => {
              console.error(error);
              this.$swal({
                title: 'Error in releasing Post, please try again',
                type: 'error'
              });
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Show success message
          this.$swal({
            title: postConfirmationText['confirm']['title'],
            text: postConfirmationText['confirm']['text'],
            type: 'success'
          });
          // Reload Page
          // this.$router.push({ path: '/posts/pending-client' });
          this.getStatusReport();
          this.$emit('input');
          this.viewPostDialog = false;
        } else {
          // Do nothing for now
        }
      });
    },
    deletePosts(postIds) {
      this.$swal({
        title: 'Are you sure?',
        text: 'Upon confirmation, the post will be deleted',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return PostAPI.bulkDeletePosts(postIds)
            .then(data => {
              return data;
            })
            .catch(error => {
              console.error(error);
              this.$swal({
                title: 'Error in deleting Post, please try again',
                type: 'error'
              });
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Show success message
          this.$swal({
            title: 'Success',
            text: 'Successfully Deleted',
            type: 'success'
          });
          // Reload Page
          // this.$router.push({ path: '/posts/pending-kobe' });
          this.$emit('input');
          this.getPosts();
          this.viewPostDialog = false;
        } else {
          // Do nothing for now
        }
      });
    },
    startSubmissionReview(post) {
      this.$router.push({ name: 'posts-submission-review', query: { id: post._id } });
    },
    submitPostPayout(post) {
      this.$router.push({ path: '/submit-post-payout', query: { id: post._id } });
    },
    enterPostURL(post) {
      campaignAPIs.getCampaign(post.campaignID)
        .then(response => {
          this.campaignDataForAddPost = response;
          this.postIdToUpdate = post._id;
          this.addPostToCampaign = true;
          this.addPost = post
        })
        .catch(err => {
          this.addPostToCampaign = true;
          this.$swal({
            type: 'error',
            title: 'Error Getting Campaign Information'
          });
          console.log(err);
        });
    },
    assignPostURL(post) {
      let postConfirmationText = postConfig.postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        input: postConfirmationText['confirmation']['type'],
        inputPlaceholder: postConfirmationText['confirmation']['placeholder'],
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          PostAPI.publishPost(post._id, result.value)
            .then(() => {
              this.$swal({
                title: postConfirmationText['confirm']['title'],
                text: 'Do you want to submit payout?',
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes'
              }).then(confirmed => {
                if (confirmed.value) {
                  let payout = {
                    campaignName: post.campaignName,
                    campaignID: post.campaignID,
                    postID: post._id,
                    influencerID: post.influencerID,
                    instagramPostURL: result.value,
                    otherSocialMediaPostUrl: '',
                    satisfactionLevel: 0,
                    advertiserSatisfactionLevel: 0
                  };
                  paymentAPIs
                    .createCampaignPayout(payout)
                    .then(() => {
                      this.$swal({
                        type: 'success',
                        title: 'Campaign payout created!'
                      });
                    })
                    .catch(() => {
                      this.$swal({
                        type: 'error',
                        title: 'Cannot create campaign payout for this post. Try again later!'
                      });
                    });
                }
              });
              this.getPosts();
              // this.$router.push({ path: '/posts/published' });
            })
            .catch(() => {
              this.$swal({
                type: 'error',
                title: 'Error in processing your request! Please try again'
              });
            });
        }
      });
    },
    completePost(post) {
      let postConfirmationText = postConfig.postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        type: postConfirmationText['confirmation']['type'],
        confirmButtonText: postConfirmationText['confirmation']['confirmText'],
        cancelButtonText: postConfirmationText['confirmation']['cancelText'],
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          PostAPI.completePost(post._id)
            .then(() => {
              this.$swal({
                type: 'success',
                title: postConfirmationText['confirm']['title'],
                text: postConfirmationText['confirm']['text']
              }).then(() => {
                this.getPosts();
                // this.$router.push({ path: '/posts/completed' });
              });
            })
            .catch(error =>
              this.$swal({
                type: 'error',
                text: error
              })
            );
        }
      });
    },
    async markMetadataTag(ids) {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to mark as metadata tagged?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          let data = ids.map(postID => {
            return Object.assign({}, {
              id: postID,
              metadataTagged: true
            })
          })
          // Submit request to save post data
          await this.$store.dispatch('post/updatePostByIds', data)
          this.isLoading = false;
          if (!this.postUpdateStatus) {
            this.$swal({
              text: 'Error Metadata Tag.',
              type: 'error'
            });
            return
          }
          // Show success message
          this.$swal({
            text: 'Successfully Saved Metadata Tag.',
            type: 'success'
          });
          this.getPosts();
        }
      })
    },
    editPostFromView: function(post) {
      this.editPost(post);
    },
    editPost(post) {
      this.fetchPostAsync(post._id).then((newPost) => {
        post.reportAbuse = newPost.reportAbuse
        this.editPostData = post;
        this.editPostDialog = true;
      });
    },
    reloadPostView(postData) {
      this.viewPostDialog = false;
      this.viewDetailPost(postData);
    },
    fetchPostAsync(postId, returnData) {
      return new Promise((resolve, reject) => {
        PostAPI.getPostById(postId)
        .then(post => {
          // this.viewPostData = post;
          resolve(post)
        })
        .catch(err => {
          this.$swal({
            title: `Couldn't the Post`,
            type: 'error',
            text: err
          });
          reject(err);
        });
      })
    },
    async getAllCampaignPayouts() {
      let response = await influencerAPIs.getAllCampaignPayouts()
      let datas = response.data
      // For now, we only retrieve Instagram info
      const campaignPayouts = datas.map(element => {
        return Object.assign(
          {
            id: element.id,
            campaignID: element.campaignID,
            influencerID: element.influencerID,
            postID: element.postID
          }
        )
      })
      this.reportData = this.reportData.map(post => {
        let matchItem = campaignPayouts.find(d => d.influencerID === post.influencerID && d.campaignID === post.campaignID)
        if (matchItem) {
          post.payout = true
        }
        return post
      })
    },
    resetFilter() {
      this.filter = {
        instagramHandle: '',
        campaignID: '',
        clientID: '',
        status: [
          config.postStatus.AD_STRATEGIST_PENDING,
          config.postStatus.CLIENT_PENDING,
          config.postStatus.APPROVE
        ]
      }
      this.filter = Object.assign({}, this.filter, this.pagging)
      this.resetPaging()
      this.getStatusReport()
    },
    resetPaging() {
      this.pagging.page = 1
      this.pagging.totalItems = 0
    },
    disableViewScreenshot(item) {
      return !item.images.length > 0 && !item.posts.length > 0 && !item.stories.length > 0 && !item.deliverablePosts.length > 0
    },
    filterMenuOptions() {
      let options = postConfig.menuActions;
      if (this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH) {
        this.menuOptions = options;
      } else {
        this.menuOptions = options.filter(option => this.buttonShow(option.action));
      }
    },
    filterTableActions() {
      let options = postConfig.tableActions;
      if (this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH) {
        this.tableActions = options;
      } else {
        this.tableActions = options.filter(option => this.buttonShow(option.action));
      }
      this.tableActions = this.tableActions.map(item => {
        item.disabled = true;
        return item;
      });
    },
    buttonShow(type) {
      const buttonPermission = config['userPermissions']['post'][type];
      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole);
      } else if (typeof buttonPermission === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.postStatus.includes(this.postStatus);
      }
    },
    actionPostBy(action, post) {
      switch (action) {
        case 'view':
          this.viewDetailPost(post);
          break;
        case 'edit':
          this.editPost(post);
          break;
        case 'assignCampaign':
          this.assignCampaignToPost(post);
          break;
        case 'mapInfluencer':
          this.mapInfluencerToPost(post);
          break;
        case 'csApprove':
          this.csApprovePost(post);
          break;
        case 'saleApprove':
          this.saleReleasePost(post);
          break;
        case 'clientReview':
          this.startSubmissionReview(post);
          break;
        case 'enterPostURL':
          this.enterPostURL(post);
          break;
        case 'markAsMetadataTagged':
          this.markMetadataTag([post._id]);
          break;
        case 'markAsComplete':
          this.completePost(post);
          break;
        case 'markAsAbuseResolved':
          this.abuseResolvePosts([post._id]);
          break;
        case 'releaseAbuseResolved':
          this.releaseAbuseResolvedPosts([post._id]);
          break;
        case 'submitPostPayout':
          this.submitPostPayout(post);
          break;
        case 'changePostStatus':
          this.changePostStatus(post);
      }
    },
    assignCampaignToPost(post) {
      this.assignCampaignPostData = post;
      this.assignCampaignDialog = true;
    },
    mapInfluencerToPost(post) {
      this.mapInfluencerPostData = post;
      this.mapInfluencerDialog = true;
    },
    changePostStatus(post) {
      this.postDataForChangeStatus = post;
      this.changePostIds = []
      this.changeStatusDialog = true;
    },
    assignedCampaign() {
      this.getStatusReport();
    },
    postAdded() {
      this.addPostToCampaign = false;
      this.$swal({
        type: 'success',
        title: 'Post URL is added, You can now see in Campaign Report'
      });
      this.getStatusReport();
    }
  }
}
</script>

<style scoped>
.v-card .loading-dialog-text,
.theme--light.v-card .loading-dialog-text,
.theme--dark.v-card .loading-dialog-text {
  color: var(--ims-color-secondary) !important;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// statusReport.vue?2db23b7a